import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const emailTemplateAPI = {
  // 이메일 템플릿 저장 API
  async postEmailTemplateAPI(type: string, language: string, title: string, content: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const data = { type: type, language: language, title: title, content: content };
      const response = await httpService.post(
        END_POINT.emailTemplateController.postEmailTemplate(), data,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );
      // console.log('이메일 템플릿 저장 성공: ', content, response);
      return response;
    } catch (error) {
      // console.log('이메일 템플릿 저장 전달된 데이터: ', content);
      console.error('이메일 템플릿 저장 실패: ', error);
      throw error;
    }
  },
  // 이메일 템플릿 테스트 API
  async postEmailTemplateTestAPI(type: string, language: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response = await httpService.post(
        END_POINT.emailTemplateController.postEmailTemplateTest(type, language), null,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
          }
        }
      );
      // console.log('이메일 템플릿 저장 성공: ', content, response);
      return response;
    } catch (error) {
      // console.log('이메일 템플릿 저장 전달된 데이터: ', content);
      console.error('이메일 템플릿 저장 실패: ', error);
      throw error;
    }
  }
};

export const { postEmailTemplateAPI, postEmailTemplateTestAPI } = emailTemplateAPI;
